<div class="mt-3">
  <cap-rubrik [isClosable]="true" [isOpen]="true" id="rubrik">
    <ng-container class="mt-2" title>
      <h3 class="mb-0">{{ "configuration.reihenfolge" + rubrikTitle | translate }}</h3>
    </ng-container>
    <div class="btn-group btn-group-sm float-end" data-toggle="buttons" titleActionButtons>
      @if (isReadOnlyMode()) {
        <button (click)="onEdit()" class="btn btn-outline-primary btn-sm" type="button">
          <i class="fas fa-pen me-2"></i>{{ "functionbar.edit" | translate }}
        </button>
      }
      @if (isEditMode()) {
        <button (click)="onCancelComponents()" class="btn btn-outline-primary btn-sm me-2" type="button">
          <i class="fas fa-times me-2"></i>{{ "functionbar.cancel" | translate }}
        </button>
      }
      @if (isEditMode()) {
        <button (click)="onSaveComponents()" class="btn btn-primary btn-sm" type="submit">
          <i class="fas fa-check me-2"></i>{{ "functionbar.save" | translate }}
        </button>
      }
    </div>
    <table class="cap-table-detail mt-2 mb-1">
      <thead>
        <tr>
          <th>{{"Rubrik"}}</th>
          <th class="text-end">{{"Anzeige" | translate}}</th>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
    <ng-template [ngTemplateOutlet]="rubrikDraggableLists"></ng-template>
  </cap-rubrik>
</div>

<ng-template #rubrikDraggableLists>
  <div>
    <div (cdkDropListDropped)="drop($event)" [cdkDropListData]="visibleComponents" cdkDropList cdkDropListDisabled="{{ !isEditMode() }}">
      @for (component of visibleComponents; track component) {
        <div cdkDrag class="rubrik-list-item input-group d-flex">
          <ng-template [ngTemplateOutlet]="rubrikRow" [ngTemplateOutletContext]="{ $implicit: component }"></ng-template>
        </div>
      }
    </div>
    <div
      (cdkDropListDropped)="drop($event)"
      [cdkDropListData]="invisibleComponents"
      cdkDropList
      cdkDropListDisabled="{{ !isEditMode() || visibleComponents.length !== 0 }}"
      class="mt-1">
      @for (component of invisibleComponents; track component) {
        <div [ngClass]="visibleComponents.length === 0 ? '' : 'rubrik-invisible'" cdkDrag class="rubrik-list-item input-group d-flex">
          <ng-template [ngTemplateOutlet]="rubrikRow" [ngTemplateOutletContext]="{ $implicit: component }"></ng-template>
        </div>
      }
    </div>
  </div>
</ng-template>

<ng-template #rubrikRow let-component>
  <label [attr.for]="'componentVisible' + component.name" [ngStyle]="{ cursor: isEditMode() ? 'pointer' : 'default' }" class="form-control">
    @if (isEditMode() && (component.visible || visibleComponents.length === 0)) {
      <i aria-hidden="true" class="fas fa-arrows-alt fa-fw text-primary" style="opacity: 0.7"></i>
    }
    {{ component.name | translate }}
  </label>
  <ng-template [ngTemplateOutlet]="anzeigeButton" [ngTemplateOutletContext]="{ $implicit: component }"></ng-template>
</ng-template>

<ng-template #anzeigeButton let-component>
  <div class="input-group-text">
    <input
      (click)="component.toggleVisible()"
      [checked]="component.visible.valueOf()"
      [disabled]="!isEditMode()"
      [id]="'componentInvisible' + component.name"
      type="checkbox" />
  </div>
</ng-template>
